import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import cn from 'classnames'
import { useDispatch } from 'react-redux'

import { getMaintenanceAssets } from '../../../api'
import { showMaintenance } from '../../../store/asset/actions'

import styles from './styles.module.scss'

import AssetStatus from '../AssetStatus'

const MaintenanceCurrent = ({companyId}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  
  const [assets, setAssets] = useState([])

  useEffect(() => {
    getAssets()
  }, [companyId])

  const getAssets = async () => {
    const res = await getMaintenanceAssets(companyId, {type: 'current'})
    if (Array.isArray(res?.data)) {
      setAssets(res.data)
    }
  }

  const handleClickComplete = (asset) => () => {
    dispatch(showMaintenance({asset_id: asset.id, maintenance_plan_id: asset.maintenance_plan.id}))
  }

  return (
    <div className={styles.container}>
      {
        assets.length === 0 && (
          <div className={styles.noAssets}>
            { t('No current maintenance records') }
          </div>
        )
      }
      <div className={styles.assets}>
        {
          assets.map((asset, i) => {
            const isOverdue = moment(asset.maintenance_date).isBefore(moment(), 'days')
            const daysOverdue = isOverdue ? moment().diff(moment(asset.maintenance_date), 'days') : 0
            return (
              <div key={i} className={cn(styles.asset, {[styles.overdue]: isOverdue})}>
                <div className={styles.assetImage}>
                  <img src={asset.details.photo} alt={asset.name} />
                </div>
                <div className={styles.assetDetails}>
                  <div>
                    <div className={styles.assetName}>{asset.name}</div>
                    <div className={styles.assetModel}>{asset.details.model}</div>
                  </div>
                  <div>
                    <div className={styles.assetName}>{asset.maintenance_plan.name}</div>
                    <div className={styles.assetModel}>{asset.maintenance_plan.schedule_type} · due {asset.maintenance_date}</div>
                  </div>
                  <div className={styles.assetAssignment}>
                    <div className={styles.assetModel}>Assigned:</div>
                    <div>{asset.employee ? `${asset.employee.name} ${asset.employee.surname}` : 'Unassigned'}</div>
                    <AssetStatus status={asset.status} />
                  </div>
                </div>
                <div className={styles.assetActions}>
                  <div className={styles.badge}>
                    {isOverdue ? t('{{daysOverdue}} days overdue', { daysOverdue }) : t('Due today') }
                  </div>
                  <button type="button" className={styles.assetActionButton} onClick={handleClickComplete(asset)}>
                    { t('Complete') }
                  </button>
                </div>
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

export default MaintenanceCurrent
